
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 3C11.45 3 11 3.45 11 4V12C11 12.55 11.45 13 12 13C12.55 13 13 12.55 13 12V4C13 3.45 12.55 3 12 3ZM17.14 5.86C16.75 6.25 16.76 6.86 17.13 7.25C18.26 8.45 18.96 10.05 19 11.82C19.09 15.65 15.92 18.95 12.09 18.99C8.18001 19.05 5.00001 15.9 5.00001 12C5.00001 10.16 5.71001 8.49 6.87001 7.24C7.24001 6.85 7.24001 6.24 6.86001 5.86C6.46001 5.46 5.81001 5.47 5.43001 5.88C3.98001 7.42 3.07001 9.47 3.00001 11.74C2.86001 16.62 6.83001 20.84 11.71 20.99C16.81 21.15 21 17.06 21 11.99C21 9.62 20.08 7.48 18.58 5.88C18.2 5.47 17.54 5.46 17.14 5.86Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-power-settings-new`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPowerSettingsNew

    ```js
    <b-new-b-icon-power-settings-new />
    ```
</docs>


